export default {
  schema: {
    type: 'object',
    title: '<span style="color:red;font-weight:bold;">!&nbsp;</span>Presentations',
    properties: {
      sample: {
        title: 'Sample Question',
        type: 'string'
      }
    }
  },
  uiSchema: {
    'ui:title': {
      text: '<span style="color:red;font-weight:bold;">!</span>Presentations',
      escape: false
    },
    text_123456789: {
      'ui:title': 'For "fun", we strip out non-breaking spaces from the title in the uiSchema, but not the schema'
    },
    sample: {
      'ui:widget': 'text'
    },
    'dm:layout': [{
      type: 'text',
      id: 'text_123456789'
    }, {
      type: 'field',
      id: 'sample'
    }]
  },
  formData: {}
};